"use strict";

import axios from 'axios';
import _ from "lodash";

import * as Products from './../api/products/products';
import * as ProductHelp from "./../api/products/product-help";
import * as ProductKeywords from './../api/products/product-keywords';
import * as ProductBarcodes from './../api/products/product-barcodes';
import * as ProductDepartments from "./../api/products/product-departments";
import * as ProductKits from './../api/products/kits';

export default {
    namespace: '/products/',

    state: {
        kitResource: {},
        productsSearch: '',
        products: [],
        displayedProducts: [],
        d: [],
        kitList: false,
        status: {
            product: {
                full_name: '',
                quantity: 0
            },
            incoming: {
                supplier_name: '',
            },
            pending: {
                supplier_name: ''
            },
            initialQ: 1,
            item: {},
            suppliers: {}
        }
    },

    getters: {
        displayedProducts: ( state ) => {
            return state.displayedProducts;
        },

        kitResource: state => {
            return state.kitResource;
        },

        productsSearch: state => {
            return state.productsSearch;
        },

        products: state => {
            return state.products;
        },

        kitList: state => {
            return state.kitList;
        },

        status: state => {
            return state.status;
        }
    },

    mutations: {
        productsSearch: ( state, text ) => {
            state.productsSearch = text;
        },

        displayedProducts: ( state, products ) => {
            state.displayedProducts = products
        },

        products: ( state, products ) => {
            state.products = products;
        },

        kitList: ( state, kitList ) => {
            state.kitList = kitList;
        },

        updateStockOrderItemBox: ( state, newBox ) => {
            state.status.item.box = newBox;
        },

        updateStockOrderItemQuantity: ( state, newQuantity ) => {
            state.status.item.quantity = newQuantity;
        },

        clearIncomingStatus: ( state ) => {
            state.status.incoming = null;
        },
        
        setStatus: ( state, newStatus ) => {
            state.status = newStatus;
        }
    },

    actions: {
        productDetail: ( { getters, commit, dispatch }, slug ) => {
            let detail = {};

            let calls = [
                Products.getProduct( slug ),
                ProductHelp.getProductHelp( slug ),
                ProductKeywords.getProductKeywords( slug )
            ];

            return new Promise( ( resolve, reject ) => {
                Promise.all( calls )
                    .then(
                        responses => {
                            detail.product = responses[ 0 ].data;
                            detail.help = responses[ 1 ].data;
                            detail.keywords = responses[ 2 ].data;

                            let barcodeCalls = [];
                            let barcodes = [];

                            if ( detail.product.children.length > 0 ) {
                                _.forEach( detail.product.children, function ( child ) {
                                    barcodeCalls.push( ProductBarcodes.getProductBarcodes( child.slug ) );
                                } );

                                Promise.all( barcodeCalls )
                                    .then(
                                        responses => {
                                            for ( let i = 0; i < responses.length; i++ ) {
                                                detail.barcodes = detail.barcodes.concat( responses[ i ].data );
                                            }
                                        },
                                        errors => {
                                            this.$snotify.console.error( 'Problem getting barcodes' );
                                        }
                                    );
                            } else {
                                ProductBarcodes.getProductBarcodes( slug ).then(
                                    ( response ) => {
                                        detail.barcodes = response.data;
                                    },
                                    ( error ) => {
                                        this.$snotify.console.error( 'Problem getting barcodes' );
                                    }
                                )
                            }

                            detail.barcodes = barcodes;
                            commit( 'productDetail', detail );
                            resolve( detail );
                        }
                    )
                    .catch( reject );
            } )
        },

        productsSearch: ( { getters, commit, dispatch }, text ) => {
            let cancelToken = axios.CancelToken;
            let previousReq = cancelToken.source();
            if (text.length > 2) {
                commit( 'productsSearch', text );
                if ( text !== '' ) {
                    dispatch( 'cancelPreviousRequest', previousReq );
                    Products.searchProducts( text, getters.previousRequest.token ).then(
                        ( response ) => {
                            commit( 'displayedProducts', response.data );
                            return Promise.resolve( response.data );
                        }
                    ).catch(
                        ( error ) => {
                            if ( !axios.isCancel( error ) ) {
                                console.log( error );
                                return Promise.reject( 'Problem searching products' );
                            }
                        }
                    )
                } else {
                    reject( 'Text is blank' );
                }
            }
        },

        productStatus: ( { state, dispatch, commit }, slug ) => {
            Products.getProductStockStatus( slug ).then(
                ( response ) => {
                    state.status = response.data;
                    commit( 'currentSupplier', response.data.suppliers[ 0 ] );
                    dispatch( 'orderItem' );
                }
            )
        },

        removeProductKeyword: ( { state, getters, commit }, data ) => {
            let keywordSlug = data.keywordSlug;
            let productSlug = data.productSlug;
            return new Promise( ( resolve, reject ) => {
                    ProductKeywords.destroyProductKeyword( productSlug, keywordSlug  ).then(
                        ( response ) => {
                            commit( 'productDetailKeywords', _.filter(
                                getters.productDetail.keywords,
                                ( keyword ) => {
                                    return keyword.slug !== keywordSlug;
                                }
                            ) );
                            resolve( response.data )
                        },
                        ( error ) => {
                            reject( 'Problem removing keyword' );
                        }
                    );
                }
            );
        },

        getProductBarcodes: ( {}, productSlug ) => {
            return ProductBarcodes.getProductBarcodes( productSlug );
        },

        getProductsDepartments: ( { getters }, slug ) => {
            return new Promise( ( resolve, reject ) => {
                ProductDepartments.getProductDepartments( slug ).then(
                    ( response ) => {
                        resolve( response.data );
                    },
                    ( error ) => {
                        reject( 'Problem getting departments for this product' );
                    }
                )
            } );
        },

        setProductsDepartments: ( { getters }, data ) => {
            return new Promise( ( resolve, reject ) => {
                ProductDepartments.storeProductDepartments( data.productSlug, data.departments ).then(
                    ( response ) => {
                        resolve( response.data );
                    },
                    ( error ) => {
                        reject( 'Problem updating departments' );
                    }
                )
            } );
        },

    },
}
